/**
 * Şube QR kod formatı.
 * Format: "shiftbeat:sube:{subeId}"
 *
 * BOSS QR oluşturur, şubeye yapıştırır.
 * Personel okuduğunda subeId'yi parse ederiz.
 */

const PREFIX = 'shiftbeat:sube:'

export function subeQrIcerik(subeId: string): string {
  return `${PREFIX}${subeId}`
}

export interface SubeQrParseSonuc {
  basarili: boolean
  subeId?: string
  hata?: string
}

export function subeQrParse(qrIcerik: string): SubeQrParseSonuc {
  const trimmed = qrIcerik.trim()

  if (!trimmed.startsWith(PREFIX)) {
    return {
      basarili: false,
      hata: 'Bu QR Shift Beat şube QR\'ı değil.',
    }
  }

  const subeId = trimmed.substring(PREFIX.length)

  if (!subeId || subeId.length < 5) {
    return {
      basarili: false,
      hata: 'QR formatı hatalı.',
    }
  }

  return {
    basarili: true,
    subeId,
  }
}
